import useSWR from 'swr';
import { useState, useEffect, useMemo } from 'react';
import api from './axios';
import { Brand } from '../types/brand';

// Fetcher without authentication
const fetcherWOauth = (url: string) => api.get(url).then(res => res.data);

// SWR options
const options = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  errorRetryCount: 3,
};

export function useGetBrands() {
  const URL = '/api/shop/brands';

  const { data, isLoading, error } = useSWR(URL, fetcherWOauth, options);
  const [brandsData, setBrandsData] = useState<Brand[]>([]);

  useEffect(() => {
    if (!data) return;

    setBrandsData(data);
  }, [data]);

  const memoizedValue = useMemo(() => {
    return {
      brandsData,
      brandsIsLoading: isLoading,
      error,
    };
  }, [brandsData, isLoading, error]);

  return memoizedValue;
}

// Legacy API object for backward compatibility
export const brandsApi = {
  async getBrands(): Promise<Brand[]> {
    const response = await api.get<Brand[]>('/api/shop/brands');
    return response.data;
  },
};

// Keep the old function for backward compatibility
export const getBrands = async (): Promise<Brand[]> => {
  return brandsApi.getBrands();
}; 